import React, {useEffect} from 'react';
import css from './SectionHeader.module.scss';

export const SectionHeader: React.FC<{
  title: string;
  text?: string;
  children?: any;
}> = ({title, text, children}) => {
  return (
    <div className={css.section}>
      <div className={css.header}>
        <div className={css.title}>
          <div>{title}</div>
        </div>
        {text && (
          <div className={css.text}>
            <div>{text}</div>
          </div>
        )}
      </div>
      {children && <div className={css.content}>{children}</div>}
    </div>
  );
};
